import { formatText } from '../lib/utils';
import { motion } from 'framer-motion';
import { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('submitting');

    try {
      const response = await fetch('/api/send-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus('success');
        setFormData({ name: '', email: '', phone: '', message: '' });
      } else {
        setStatus('error');
      }
    } catch (error) {
      setStatus('error');
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  return (
    <motion.section
      id="contact"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="flex flex-col md:pb-[6rem] sm:pb-[5rem] pb-[5rem] lg:pb-[120px] md:pt-[6rem] sm:pt-[5rem] pt-[5rem] lg:pt-[120px] border-[#525252] border-b-[1px] border-r-[0px] border-t-[0px] border-l-[0px] xl:w-[100%] xl:max-w-[auto] w-[100%] max-w-[auto] ml-[auto] mr-[auto]"
    >
      <div className="flex flex-col w-[100%] max-w-[1280px] mr-[auto] ml-[auto] md:pr-[4rem] sm:pr-[4rem] pr-[1.5rem] lg:pr-[32px] md:pl-[4rem] sm:pl-[4rem] pl-[1.5rem] lg:pl-[32px] 2xl:max-w-[1536px]">
        <div className="flex flex-col sm:flex-row gap-[4rem] sm:gap-[12px]">
          <div className="w-[100%] flex flex-col gap-[1.5rem]">
            <h2 className="sm:text-[36px] text-[36px] md:text-[48px] w-[90%] font-semibold block leading-[1.1em]">{formatText("Gotowy na skalowanie sprzedaży? Skontaktuj się z nami!")}</h2>
            <p className="block text-[18px] text-[#a3a3a3]">{formatText("Umów się na bezpłatną konsultację i sprawdź, co możemy zrobić dla Twojego biznesu.")}</p>
            <span className="block sm:text-[24px] text-[24px] md:text-[30px]">witaj@omegapost.pl</span>
            <span className="block sm:text-[24px] text-[24px] md:text-[30px]">+48 793 959 931</span>
          </div>
          <div className="w-[100%]">
            <form onSubmit={handleSubmit} className="flex flex-col w-[100%] gap-[1rem]">
              <div className="flex flex-col gap-[8px] w-[100%]">
                <label htmlFor="name" className="block font-medium tracking-[-0.025em] text-[16px] leading-[1.5em] text-[#525252]">
                  Imię i Nazwisko
                </label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Imię i Nazwisko"
                  autoComplete="off"
                  required
                  className="cursor-default focus:outline-none pr-[16px] pl-[16px] border-solid border-[1px] disabled:opacity-[50%] rounded-[12px] placeholder-opacity-[100%] placeholder-[#a8a8a8] focus:border-opacity-[20%] w-[100%] text-[16px] leading-[1.5em] tracking-[0px] text-opacity-[100%] text-[#171717] bg-[#171717] border-[#525252] pt-[12px] pb-[12px] 2xl:text-[#ffffff]"
                />
              </div>
              <div className="flex flex-col gap-[8px] w-[100%]">
                <label htmlFor="email" className="block font-medium tracking-[-0.025em] text-[16px] leading-[1.5em] text-[#525252]">
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email address"
                  autoComplete="off"
                  required
                  className="cursor-default focus:outline-none pr-[16px] pl-[16px] border-solid border-[1px] disabled:opacity-[50%] rounded-[12px] placeholder-opacity-[100%] placeholder-[#a8a8a8] focus:border-opacity-[20%] w-[100%] text-[16px] leading-[1.5em] tracking-[0px] text-opacity-[100%] text-[#171717] bg-[#171717] border-[#525252] pt-[12px] pb-[12px] 2xl:text-[#ffffff]"
                />
              </div>
              <div className="flex flex-col gap-[8px] w-[100%]">
                <label htmlFor="phone" className="block font-medium tracking-[-0.025em] text-[16px] leading-[1.5em] text-[#525252]">
                  Nr. telefonu:
                </label>
                <input
                  type="tel"
                  name="phone"
                  id="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Nr. telefonu"
                  autoComplete="off"
                  className="cursor-default focus:outline-none pr-[16px] pl-[16px] border-solid border-[1px] disabled:opacity-[50%] rounded-[12px] placeholder-opacity-[100%] placeholder-[#a8a8a8] focus:border-opacity-[20%] w-[100%] text-[16px] leading-[1.5em] tracking-[0px] text-opacity-[100%] text-[#171717] bg-[#171717] border-[#525252] pt-[12px] pb-[12px] 2xl:text-[#ffffff]"
                />
              </div>
              <div className="flex flex-col gap-[8px] w-[100%]">
                <label htmlFor="message" className="block font-medium tracking-[-0.025em] text-[16px] leading-[1.5em] text-[#525252]">
                  Wiadomość:
                </label>
                <textarea
                  name="message"
                  id="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Wpisz wiadomość..."
                  rows={4}
                  required
                  className="cursor-default focus:outline-none pr-[16px] pl-[16px] border-solid border-[1px] disabled:opacity-[50%] rounded-[12px] placeholder-opacity-[100%] placeholder-[#a8a8a8] focus:border-opacity-[20%] w-[100%] text-[16px] leading-[1.5em] tracking-[0px] text-opacity-[100%] text-[#171717] bg-[#171717] border-[#525252] pt-[12px] pb-[12px] 2xl:text-[#ffffff]"
                ></textarea>
              </div>
              <motion.button
                whileHover={{ opacity: 0.9 }}
                whileTap={{ scale: 0.95 }}
                type="submit"
                disabled={status === 'submitting'}
                className="flex flex-row items-center justify-center text-white pr-[20px] pl-[20px] border-[transparent] border-[1px] border-solid inline-block focus:outline-none rounded-[12px] font-medium text-[16px] tracking-[-0.025em] leading-[1.5em] pt-[10px] pb-[10px] bg-opacity-[100%] bg-[#ffffff] 2xl:hover:bg-[#525252] 2xl:hover:text-[#d4d4d4] disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <span className="text-[16px] block text-[#171717] font-medium 2xl:hover:text-opacity-[100%] 2xl:hover:text-[#ffffff]">
                  {status === 'submitting' ? 'Wysyłanie...' : 'Wyślij wiadomość'}
                </span>
              </motion.button>
              {status === 'success' && (
                <p className="text-green-500 text-center mt-2">Wiadomość została wysłana pomyślnie!</p>
              )}
              {status === 'error' && (
                <p className="text-red-500 text-center mt-2">Wystąpił błąd. Spróbuj ponownie później.</p>
              )}
            </form>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default Contact;
